import Route from '@ember/routing/route';

export default class PollErrorRoute extends Route<Error> {}
